<template>
 <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
             >
            <template slot="header">
            <h4 class="card-title"> {{ $t('message.ADD_ONS')}}</h4>
            <p class="card-category">{{ $t('message.ADD_ONS_LISTING')}}</p>
            </template>
            <div class="row" style="margin-left:2px">
                <div class="col-md-3 form-group">
                    <label class="label">{{ $t('message.SEARCH_FILTER')}}</label>
                    <v-select :options="filter_type" v-model="search_filter" class="as-input-ht"></v-select>
                </div>
                <div class="col-md-6 form-group">
                        <label class="label">{{ $t('message.SEARCH')}}</label>
                        <input type="text" v-model="search_key" v-on:keyup.enter="submit" class="form-control" >
                </div>
                <div class="col-md-3 form-group">
                    <span class="float-right" style="margin-top:24px">
                        <a href="javascript:void(0);"  class="btn btn-info mr-2" id="submit">{{ $t('message.SEARCH')}}</a>
                         <a> <vue-json-to-csv :labels="labels"  :csv-title="'Products'"  :json-data="json_csv"  class="btn btn-info mr-2" > <i class="fas fa-file-csv" id="csv_id" ></i></vue-json-to-csv></a>
                        <a href="javascript:void(0);" v-on:click="get_add_ons(0)" class="btn btn-info mr-2 "><i class="fas fa-sync-alt"></i></a>
                        <a type="button" class="btn btn-info  float-right" @click="$emit('add_ons')"><i class="fa fa-plus" aria-hidden="true"></i>
                        </a>
                    </span>
                </div>
            </div>
            <table class="table">
            <thead>
                <tr>
                <th scope="col">{{ $t('message.NAME')}}</th>
                <th scope="col">Type</th>
                <th scope="col">{{ $t('message.PRICE')}}</th>
                <th scope="col">{{ $t('message.ACTION')}} </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(add_on, index) in add_ons" :key="index"> 
                <td>{{add_on.name}}</td>
                <td>{{add_on.type === 1 ? $t('message.TYPE_CAR') : (add_on.type === 2 ? $t('message.TYPE_WORK') : null)}}</td>
                <td>{{add_on.price}}</td>
                <td >
                    <a   href="javascript:void(0);"  @click="$emit('edit_add_ons', add_on)" class="mr-2"><i class="fas fa-pencil-alt"></i></a>
                    <a   href="javascript:void(0);"  v-bind:style="{color: '#dc3545'}" v-on:click="delete_add_on(add_on.id)"><i class="fas fa-trash-alt"></i></a>
                </td>
                </tr>
            </tbody>
            </table>
          </card>
        </div>
      </div>
 </div>
</template>

<script>
  import Card from '../../components/Cards/Card.vue'
  
  export default {
    components: {
      Card
    },
    data () {
      return {
        filter_type:['Name','Price'],
        search_filter:'',
        search_key: '',
        json_csv : [],
      }
    },

    computed: {
      add_ons() {
        const temp = [];
        const data =  this.$store.getters['admin_add_on/allAddOns']
        data.forEach((element, index) => {
          temp.push({
            name:element.name,
            type:element.type == 1 ? this.$t('message.TYPE_CAR') :  this.$t('message.TYPE_WORK'),
            price:element.price
          })

          this.json_csv = temp
        });
        return data;
      },
      labels () {
        return {
          name:{title:this.$t('message.NAME')},
          type: {title:"Type"},
          price: {title:this.$t('message.PRICE')},
        } 
      },
    },

    methods: {
      async get_add_ons() {
        this.search_filter = ''
        this.search_key = ''

        let loader = this.$loading.show()
        try {
          await this.$store.dispatch('admin_add_on/get_add_ons')
          loader.hide()
        } catch (e) {
          this.$store.dispatch('notifications_alert/error', "Oops, something went wrong!")
          loader.hide()
        }
      },

      async delete_add_on(add_on_id) {
        let loader = this.$loading.show()
        try {
          await this.$store.dispatch('admin_add_on/delete_add_on',add_on_id)
          loader.hide()
        } catch (e) {
          this.$store.dispatch('notifications_alert/error', "Oops, something went wrong!")
          loader.hide()
        }
      },

      submit() {
        document.getElementById('submit').click()
      }
    },
    created() {
      this.get_add_ons()
    }
  }
</script>

<style>

.as-input-ht .vs__dropdown-toggle {
    min-height: 34px!important;
    border-radius: 2px!important;
    height: 40px;

}
.as-input-ht .vs__selected {
    margin: 8px 2px 0!important;
    background-color: #fff!important;
    border-radius: 2px!important
}
</style>